module.exports = __webpack_public_path__ + "img/cocoApp.26160a82.png";